module.exports = __webpack_public_path__ + "assets/img/shop_tit.6992d086.png";